export const EMPLOYEE_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const EMPLOYEE_IMAGE_MAX_DIMENSION = 8000;
export const EMPLOYEE_IMAGE_MIN_DIMENSION = 64;
export const EMPLOYEE_IMAGE_CROP_OUTPUT_SIZE = 1024;

const ALLOWED_MIME_TYPES = new Set(["image/jpeg", "image/png", "image/webp"]);

const loadImageFromFile = (file) => new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(image);
    };

    image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("image.loadFailed"));
    };

    image.src = objectUrl;
});

export const validateEmployeeImageFile = async (file) => {
    if (!file) {
        return "image.noneSelected";
    }

    if (!ALLOWED_MIME_TYPES.has(file.type)) {
        return "image.formats";
    }

    if (file.size > EMPLOYEE_IMAGE_MAX_BYTES) {
        return "image.maxSize";
    }

    let image;
    try {
        image = await loadImageFromFile(file);
    } catch {
        return "image.loadFailed";
    }

    const { naturalWidth: width, naturalHeight: height } = image;

    if (width > EMPLOYEE_IMAGE_MAX_DIMENSION || height > EMPLOYEE_IMAGE_MAX_DIMENSION) {
        return { key: "image.maxResolution", params: { max: EMPLOYEE_IMAGE_MAX_DIMENSION } };
    }

    if (width < EMPLOYEE_IMAGE_MIN_DIMENSION || height < EMPLOYEE_IMAGE_MIN_DIMENSION) {
        return { key: "image.minResolution", params: { min: EMPLOYEE_IMAGE_MIN_DIMENSION } };
    }

    return null;
};

const createImage = (url) => new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", () => reject(new Error("image.loadFailed")));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
});

export const getCroppedEmployeeImageBlob = async (imageSrc, pixelCrop, outputSize = EMPLOYEE_IMAGE_CROP_OUTPUT_SIZE) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (!context) {
        throw new Error("crop.processFailed");
    }

    canvas.width = outputSize;
    canvas.height = outputSize;

    context.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        outputSize,
        outputSize,
    );

    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (!blob) {
                    reject(new Error("crop.processFailed"));
                    return;
                }
                resolve(blob);
            },
            "image/jpeg",
            0.92,
        );
    });
};
